module.exports = __webpack_public_path__ + "img/feature-list.b8607fe2.svg";